import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviousQuestionPaperComponent } from './components/previous-question-paper/previous-question-paper.component';
import { PreviousQuestionPaperDetailsComponent } from './components/previous-question-paper-details/previous-question-paper-details.component';
import { AuthorizationModule } from '../../authorization/authorization.module';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { BackButtonModule } from '../../common/back-button/back-button.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	suppressScrollX: true
};


@NgModule({
  imports: [
		CommonModule,
		PerfectScrollbarModule,
		AuthorizationModule,
		BackButtonModule
  ],
  declarations: [PreviousQuestionPaperComponent, PreviousQuestionPaperDetailsComponent],
  providers: [
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		}]
})
export class PreviousQuestionPaperModule { }
